// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAnalytics from 'vue-analytics'
import 'vuetify/dist/vuetify.min.css'
//import i18n from './setup/l18n-setup'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import axios from 'axios';
import * as messages from "@/lang";

import fontawesome from '@fortawesome/fontawesome'
import faUser from '@fortawesome/fontawesome-pro-solid/faUser'
import faUsers from '@fortawesome/fontawesome-pro-solid/faUsers'
import faSync from '@fortawesome/fontawesome-pro-solid/faSync'
import faHeart from '@fortawesome/fontawesome-pro-solid/faHeart'
import faCheck from '@fortawesome/fontawesome-pro-solid/faCheck'
import faCaretUp from '@fortawesome/fontawesome-pro-solid/faCaretUp'
import faCaretDown from '@fortawesome/fontawesome-pro-solid/faCaretDown'
import faHandshake from '@fortawesome/fontawesome-pro-solid/faHandshake'
import faWarning from '@fortawesome/fontawesome-pro-solid/faExclamationTriangle'
import faClipboard from '@fortawesome/fontawesome-pro-solid/faClipboard'
import faRocket from '@fortawesome/fontawesome-pro-solid/faRocket';
import faServer from '@fortawesome/fontawesome-pro-solid/faServer';
import faSpinner from '@fortawesome/fontawesome-pro-solid/faSpinner';

fontawesome.library.add(faUser);
fontawesome.library.add(faUsers);
fontawesome.library.add(faSync);
fontawesome.library.add(faHeart);
fontawesome.library.add(faCheck);
fontawesome.library.add(faCaretUp);
fontawesome.library.add(faCaretDown);
fontawesome.library.add(faHandshake);
fontawesome.library.add(faWarning);
fontawesome.library.add(faClipboard);
fontawesome.library.add(faRocket);
fontawesome.library.add(faServer);
fontawesome.library.add(faSpinner);

//console.log( "NODE_ENV", process.env.NODE_ENV );

window.moment = require('moment');

Vue.config.productionTip = false

window.numberWithCommas = function(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

Vue.use(VueAnalytics, {
    id: "UA-114940331-1",
    router
});

Vue.filter('capitalize', function (value) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1)
});

Vue.filter('allCaps', function (value) {
    if (!value) return '';
    value = String(value).toUpperCase();
    return value;
});

Vue.filter('yyyymmdd', function(value) {
    return window.moment(value).format("YYYY-MM-DD");
});

Vue.filter('numPercent', function(value, total) {
    try {
        let percent = ((value * 100) / total).toFixed(0);
        value = value.toFixed(0);
        return `${value} (${percent}%)`;
    }catch(err) {
        return "ERROR";
    }
});

const i18n = new VueI18n({
    locale: 'en', // set locale
    messages: process.env.DYNAMIC_LOCALE !== "true" ? messages : {en: messages.en}, // set locale messages
    fallbackLocale: 'en',
    // fallbackLocale: 'en',
});

const loadedLanguages = ['en']; // our default language that is prelaoded
function setI18nLanguage (lang) {
    i18n.locale = lang;

    if( lang === "en-gb" ) {
        moment.locale('en-gb')
    }else {
        moment.locale(lang);
    }

    //console.log( moment.locale(),  " is the moment locale");
    //console.log("ALL LOADED LOCALES MOMENT:", moment.locales() );
    axios.defaults.headers.common['Accept-Language'] = lang;
    document.querySelector('html').setAttribute('lang', lang);
    return lang;
}

export function switchLocale(locale) {
    if (locale === "en" || locale === "en-gb" || process.env.DYNAMIC_LOCALE !== "true" ) {
        setI18nLanguage(locale);
        return Promise.resolve( locale );
    }
    else {
        return loadLanguageAsync( locale );
    }
}

export function loadLanguageAsync (lang) {
    //if (i18n.locale !== lang) {
        return new Promise( function(resolve,reject) {
            axios.get(`/api/language/${lang}`).then( (response) => {
                let msgs;
                // console.log(response.data);
                msgs = response.data;
                try {
                    i18n.setLocaleMessage(lang, msgs);
                    loadedLanguages.push(lang);
                    setI18nLanguage(lang);
                    return resolve(lang);
                }
                catch (err) {
                    console.error("loading translation error: ", err);
                    return reject(
                        new Error('Loading the translation file was unsuccessful, this is probably due to a syntax error like a missing comma or quote\n\n' +
                                  err.message));
                }
            }).catch(( err ) => {
                return reject(
                    new Error('ERROR: Downloading remote file, this is likely a Elven Status Issue, try again and if it persists contact Blake\n\n' +
                              err));
            });
        });
        // if (!loadedLanguages.includes(lang)) {
        //     return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}`).then(msgs => {
        //         i18n.setLocaleMessage(lang, msgs.default)
        //         loadedLanguages.push(lang)
        //         return setI18nLanguage(lang)
        //     })
        // }
        // return Promise.resolve(setI18nLanguage(lang))
    //}
    //return Promise.resolve(lang)
}

export function getHighchartLanguageOptions() {
    return {
            lang: {
                loading: 'Loading...',
                months: moment.months(),
                weekdays: moment.weekdays(),
                shortMonths: moment.monthsShort(),
                drillUpText: i18n.t('site.fellowship.barCharts.drillDown').replace("{0}, {series.name}")
            }
        };
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
    i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js